export var ChunkHashAlgorithm = /*#__PURE__*/function (ChunkHashAlgorithm) {
  ChunkHashAlgorithm["Sha256"] = "sha256";
  return ChunkHashAlgorithm;
}({});